module.exports = __webpack_public_path__ + "files/a97bb125794870f273b93e53a42043f4.svg";